export const Restultado = () => {
  return <div>Restultado</div>
}
